import { render } from "./gameReportNext.vue?vue&type=template&id=80eb9032&scoped=true"
import script from "./gameReportNext.vue?vue&type=script&lang=js"
export * from "./gameReportNext.vue?vue&type=script&lang=js"

import "./gameReportNext.vue?vue&type=style&index=0&id=80eb9032&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80eb9032"]])

export default __exports__